import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "card" }
const _hoisted_2 = {
  style: {"margin-bottom":"10px"},
  class: "grid ml-0 mr-1"
}
const _hoisted_3 = { class: "flex flex-auto p-input-icon-left p-input-icon-right mt-1" }
const _hoisted_4 = { class: "flex align-items-center" }
const _hoisted_5 = { class: "flex ml-4 mr-4" }
const _hoisted_6 = { class: "propertylist-container" }
const _hoisted_7 = {
  key: 1,
  class: "text-color-secondary text-sm"
}
const _hoisted_8 = {
  key: 0,
  class: "pi pi-check"
}
const _hoisted_9 = ["onClick"]
const _hoisted_10 = { style: {"padding-bottom":"15px"} }
const _hoisted_11 = { class: "p-text-secondary" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputText = _resolveComponent("InputText")!
  const _component_InputSwitch = _resolveComponent("InputSwitch")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Message = _resolveComponent("Message")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Column = _resolveComponent("Column")!
  const _component_Badge = _resolveComponent("Badge")!
  const _component_DataTable = _resolveComponent("DataTable")!
  const _component_Timeline = _resolveComponent("Timeline")!
  const _component_Sidebar = _resolveComponent("Sidebar")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[7] || (_cache[7] = _createElementVNode("i", { class: "pi pi-home" }, null, -1)),
        _createVNode(_component_InputText, {
          modelValue: _ctx.filterText,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.filterText) = $event)),
          placeholder: "Property keyword filter.."
        }, null, 8, ["modelValue"]),
        _cache[8] || (_cache[8] = _createElementVNode("i", { class: "pi pi-search" }, null, -1))
      ]),
      _createElementVNode("div", _hoisted_4, [
        _withDirectives(_createElementVNode("a", {
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.propertyListExcelExport && _ctx.propertyListExcelExport(...args))),
          class: "css-image excel-icon mt-1"
        }, null, 512), [
          [
            _directive_tooltip,
            'Export to Excel',
            void 0,
            { top: true }
          ]
        ]),
        _createElementVNode("div", _hoisted_5, [
          _withDirectives(_createElementVNode("a", {
            class: _normalizeClass(["css-image", _ctx.filterNorthIsland ? 'north-island-icon':'north-island-disabled-icon']),
            style: {"position":"absolute","margin-top":"-15px","height":"20px","width":"30px"},
            onClick: _cache[2] || (_cache[2] = ($event: any) => {_ctx.filterNorthIsland = !_ctx.filterNorthIsland;_ctx.filterSouthIsland = false;})
          }, null, 2), [
            [
              _directive_tooltip,
              'Show properties in North Island',
              void 0,
              { top: true }
            ]
          ]),
          _withDirectives(_createElementVNode("a", {
            class: _normalizeClass(["css-image", _ctx.filterSouthIsland ? 'south-island-icon':'south-island-disabled-icon']),
            style: {"position":"absolute","margin-top":"5px","height":"20px","width":"30px"},
            onClick: _cache[3] || (_cache[3] = ($event: any) => {_ctx.filterSouthIsland = !_ctx.filterSouthIsland;_ctx.filterNorthIsland = false;})
          }, null, 2), [
            [
              _directive_tooltip,
              'Show properties in South Island',
              void 0,
              { top: true }
            ]
          ])
        ]),
        _createVNode(_component_InputSwitch, {
          modelValue: _ctx.onlyActive,
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.onlyActive) = $event)),
          class: "ml-4 mr-1 mt-1"
        }, null, 8, ["modelValue"]),
        _createElementVNode("a", {
          class: "mr-4 mt-1",
          onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.onlyActive=!_ctx.onlyActive))
        }, "Only active"),
        _createVNode(_component_Button, {
          icon: "pi pi-plus",
          label: "New",
          onClick: _ctx.newProperty,
          class: "p-button-rounded mt-1"
        }, null, 8, ["onClick"])
      ])
    ]),
    (_ctx.propertyListError)
      ? (_openBlock(), _createBlock(_component_Message, {
          key: 0,
          severity: "error"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.propertyListError), 1)
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_6, [
      _createVNode(_component_DataTable, {
        value: _ctx.filteredPropertyList,
        datakey: "propertyId",
        paginator: true,
        rows: 100,
        scrollable: true,
        scrollHeight: "flex",
        stripedRows: "",
        class: "p-datatable-sm",
        rowClass: _ctx.applyRowClass,
        paginatorTemplate: _ctx.paginatorTemplate,
        rowsPerPageOptions: [10,20,50,100,200],
        responsiveLayout: "scroll",
        currentPageReportTemplate: "Showing {first} to {last} of {totalRecords}"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_Column, {
            header: "ID",
            style: {"flex-grow":"0","flex-basis":"80px"}
          }, {
            body: _withCtx(({data}) => [
              _createVNode(_component_router_link, {
                to: { name: 'PropertyDetails', params: { propertyId: data.propertyId }}
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(data.propertyId), 1)
                ]),
                _: 2
              }, 1032, ["to"])
            ]),
            _: 1
          }),
          _createVNode(_component_Column, { header: "Property" }, {
            body: _withCtx(({data}) => [
              _createElementVNode("div", null, [
                _createVNode(_component_router_link, {
                  to: { name: 'PropertyDetails', params: { propertyId: data.propertyId }}
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(data.propertyNameAndLocation), 1)
                  ]),
                  _: 2
                }, 1032, ["to"]),
                (!data.active)
                  ? (_openBlock(), _createBlock(_component_Badge, {
                      key: 0,
                      class: "small-grey-badge ml-1",
                      value: "inactive"
                    }))
                  : _createCommentVNode("", true),
                (data.buildingName)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(data.buildingName), 1))
                  : _createCommentVNode("", true)
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_Column, {
            header: "Location",
            class: "flex",
            style: {"flex-basis":"100px"}
          }, {
            body: _withCtx(({data}) => [
              _createElementVNode("span", null, _toDisplayString(data.propertyLocation), 1),
              (data.isle == 'NI SI')
                ? _withDirectives((_openBlock(), _createBlock(_component_Badge, {
                    key: 0,
                    class: "css-image new-zealand-icon island-badge ml-1"
                  }, null, 512)), [
                    [
                      _directive_tooltip,
                      'North & South Island',
                      void 0,
                      { top: true }
                    ]
                  ])
                : (data.isle == 'NI')
                  ? _withDirectives((_openBlock(), _createBlock(_component_Badge, {
                      key: 1,
                      class: "css-image north-island-icon island-badge ml-1"
                    }, null, 512)), [
                      [
                        _directive_tooltip,
                        'North Island',
                        void 0,
                        { top: true }
                      ]
                    ])
                  : (data.isle == 'SI')
                    ? _withDirectives((_openBlock(), _createBlock(_component_Badge, {
                        key: 2,
                        class: "css-image south-island-icon island-badge ml-1"
                      }, null, 512)), [
                        [
                          _directive_tooltip,
                          'South Island',
                          void 0,
                          { top: true }
                        ]
                      ])
                    : _createCommentVNode("", true)
            ]),
            _: 1
          }),
          _createVNode(_component_Column, {
            class: "hidden lg:block",
            field: "complianceSchedule",
            header: "BWOF #",
            style: {"flex-grow":"0","flex-basis":"100px"}
          }),
          _createVNode(_component_Column, {
            class: "hidden lg:block text-center",
            field: "active",
            header: "Active",
            style: {"flex-grow":"0","flex-basis":"60px"}
          }, {
            body: _withCtx(({data}) => [
              (data.active)
                ? (_openBlock(), _createElementBlock("i", _hoisted_8))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }),
          _createVNode(_component_Column, {
            class: "hidden md:block",
            style: {"flex-grow":"0","flex-basis":"120px"}
          }, {
            body: _withCtx(({data}) => [
              _createElementVNode("a", {
                style: {"cursor":"pointer"},
                onClick: ($event: any) => (_ctx.clickSidebar(data))
              }, [...(_cache[9] || (_cache[9] = [
                _createElementVNode("i", { class: "pi pi-info-circle" }, null, -1)
              ]))], 8, _hoisted_9)
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["value", "rowClass", "paginatorTemplate"]),
      _createVNode(_component_Sidebar, {
        visible: _ctx.propertyListSidebar,
        "onUpdate:visible": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.propertyListSidebar) = $event)),
        baseZIndex: 1000,
        position: "right"
      }, {
        default: _withCtx(() => [
          _createElementVNode("h3", null, _toDisplayString(_ctx.sidebarDataName), 1),
          _createVNode(_component_Timeline, { value: _ctx.services }, {
            content: _withCtx((slotProps) => [
              _createElementVNode("div", _hoisted_10, _toDisplayString(slotProps.item.serviceName), 1)
            ]),
            opposite: _withCtx((slotProps) => [
              _createElementVNode("small", _hoisted_11, _toDisplayString(_ctx.formattedDate(slotProps.item.whenCreated)), 1)
            ]),
            _: 1
          }, 8, ["value"])
        ]),
        _: 1
      }, 8, ["visible"])
    ])
  ]))
}